import { Input } from "antd";
import React from "react";
import Button from "../Button";
import { Link } from "react-router-dom";

const inputClass = "border-2 border-b-2 rounded-none";

const SellerMessage = ({ reply }) => {
  return (
    <div className="offset-form">
      <Input.TextArea
        readOnly
        showCount
        placeholder="Write a Message"
        className="border-2 focus-within:shadow-none rounded-lg font-spaceGrotesk my-4"
        style={{ height: 60, resize: "none", width: "40rem" }}
        value={reply?.remarks}
      />

      {(reply?.document_list || []).map(
        ({ doc_name, doc_file, text_required, text, file }, index) => (
          <div className="flex flex-row flex-wrap items-center mb-1" key={`docs_${index}`}>
            <label className=" capitalize flex gap-x-4 mr-3">
              <pre className="text-xs">{index + 1}.</pre>
              <div className="text-xs">{doc_name}*</div>
            </label>
            {text_required && (
              <div className={"mr-6 flex-grow"}>
                <Input className={inputClass} value={text} />
              </div>
            )}
            {doc_file && (
              <Link to={file} target="_blank">
                <Button
                  varient={"primary"}
                  color={"blue"}
                  className={
                    "px-4 py-1 rounded-[0.2rem] text-xs text-white font-medium flex justify-center gap-x-2 items-center"
                  }
                >
                  View
                </Button>
              </Link>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default SellerMessage;
